import moment from "moment";
import React from "react";
import Swal from "sweetalert2";
import axios from "../../../axios/axios";
import UpdateCircular from "./../UpdateCircular/UpdateCircular";

const Circular = ({ circular, index, isUpdate, setIsUpdate }) => {
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`/circulars/${id}`);
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
          setIsUpdate(!isUpdate);
        } catch (error) {
          Swal.fire("Error!");
        }
      }
    });
  };

  return (
    <tr>
      <th>{index + 1}</th>
      <th>{circular?.title}</th>
      <td>{circular?.description}</td>
      <td>{moment(circular?.circular_date).format("DD-MM-YYYY")}</td>
      <td>
        <img
          style={{ height: "32px", width: "32px", borderRadius: "5px" }}
          src={circular?.image_url}
          alt={index + 1}
        />
      </td>
      <td>{circular?.pdf_url}</td>
      <td style={{ minWidth: "100px" }}>
        <UpdateCircular
          circular={circular}
          index={index}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
        />
        <button
          style={{
            backgroundColor: "red",
            border: "none",
            borderRadius: "5px",
            marginLeft: "5px",
          }}
          onClick={() => handleDelete(circular?.id)}
        >
          <i
            style={{
              color: "white",
              padding: "7px 3px",
              fontSize: "15px",
            }}
            className="fa fa-trash-o"
          ></i>
        </button>
      </td>
    </tr>
  );
};

export default Circular;
